export const brand = {
  shortName: 'SLAD',
  fullName: 'Sed lex antea diversi',
  description: 'Tracing changes in Sri Lankan legislation',
} as const;
